// NOTE: endpoint paths are placeholders pending the final BE API contract for the plan/pass flow.
const urlHelper = {
  getPlanDetails(payload: any) {
    return `/rest/consigner/v2/web/balance/pass?code=${payload.code}`;
  },
  initiatePlanPayment() {
    return `/rest/consigner/v1/web/pay/pass/create-order`;
  },
  initiatePlanPaymentStatus() {
    return `/rest/consigner/v1/web/pay/pass/complete-order`;
  },
};

export default urlHelper;
